// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { CompanyFundsQuoteBetaModule } from './app.module';
bootstrapAppModule(CompanyFundsQuoteBetaModule);
